import { RequestService } from "@/services/request.service";
import errorManager from "@/services/error.manager";
const requestService = new RequestService();

export default {
  methods: {
    getUserData(context) {
      requestService.getUserData(context).catch((error) => {
        errorManager.manageError(context, error);
      });
    },
  },
};
